/* Rack Column Configuration Section */

.rackColumnsSection {
  /* margin: 20px 0; */
}

/* Section header */
.sectionHeader {
  margin-bottom: 20px;
}

.sectionTitle {
  font-size: 20px;
  font-weight: 400;
  color: #505050;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

/* Column tabs wrapper */
.columnTabsWrapper {
  margin-bottom: 20px;
}

/* Configurations wrapper */
.configurationsWrapper {
  width: 100%;
  overflow: hidden;
}

.rackColumnsSection {
  max-width: 400px;
}

/* Override the ButtonImageSelect container to prevent horizontal scroll */
.rackColumnsSection > div {
  max-width: 400px;
  overflow-x: scroll;
}

/* Adjust button size for wrapping layout */
.rackColumnsSection button {
  min-width: 85px;
  max-width: 85px;
  padding: 10px 6px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.rackColumnsSection button:hover {
  border-color: #9ca3af;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.rackColumnsSection button[aria-checked='true'] {
  border-color: #6b7280;
  background-color: #f9fafb;
  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.1);
}

/* Override ButtonImageSelect styles to match design */
.configurationsWrapper button {
  min-width: 120px;
  padding: 14px 10px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  transition: all 0.2s ease;
}

.configurationsWrapper button:hover {
  border-color: #9ca3af;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.checkmarkContainer {
  color: #fffdf7;
}

.configurationsWrapper button[aria-checked='true'] {
  border-color: #6b7280;
  background-color: #fffdf7;
  box-shadow: 0 0 0 3px rgba(107, 114, 128, 0.1);
}

/* Icon content area */
.configurationsWrapper button > div:first-child {
  margin-bottom: 8px;
}

/* Label text */
.configurationsWrapper button > div:last-child {
  font-size: 13px;
  font-weight: 300;
  color: #505050;
  line-height: 1.3;
  text-align: center;
  max-width: 100px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .rackColumnsSection button {
    min-width: 75px;
    max-width: 75px;
  }
}
